/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css?family=Noto+Sans);h2[_ngcontent-%COMP%]{text-align:center;font-family:'Noto Sans'}.wrapper[_ngcontent-%COMP%]{text-align:center}[_nghost-%COMP%]     .ui-inputtext{text-align:center}"];
export { styles as styles };
